<template>
	<div class="variant">
		<div class="cells">
			<div class="cell-image"/>
			<div class="cell-title" v-text="variant.description"/>
			<div class="cell-price" v-text="price"/>
			<div class="cell-quantity">
				<counterFull v-if="type === 'cart'" v-bind="{props: {rules: variant.rules, productId: product.id, variantId: variant.id}}"/>
				<template v-else>{{quantity}}stk.</template>
			</div>
			<div class="cell-total" v-text="totalPrice"/>
			<div class="cell-remove" v-if="type === 'cart'">
				<a class="icon" @click="remove" v-html="require('@/assets/icons/times-regular.svg')"/>
			</div>
		</div>
	</div>
</template>

<script>
import {price} from "@/modules/utils";
import counterFull from "@/components/counter/full.vue";

export default {
	components: {counterFull},
	props: {
		id: {type: Number, required: true},
		type: {type: String, required: true},
		variant: {type: Object, required: true},
		quantity: {type: Number, required: true},
		total_price: {type: Number, required: true}
	},
	computed: {
		product: (t) => t.variant.product,
		price: (t) => price(t.variant.price),
		totalPrice: (t) => price(t.total_price)
	},
	methods: {
		remove() {
			this.$store.dispatch("cart/removeItem", {itemId: this.id});
		}
	}
};
</script>

<style lang="scss" scoped>
.variant {
	.cells {
		> div {
			margin: -0.6em 0;

			&:last-child {
				padding-right: 0;
			}
		}

		.cell {
			&-quantity {
				height: 68px;
				display: flex;
				align-items: center;
			}
			&-remove {
				.icon {
					/deep/ svg {
						$s: 10px;
						width: $s;
						height: $s;
					}
				}
			}
		}
	}
}
</style>
